export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Burnt Sugar ( Poudre )-7c5d4717aec005cc3867b07a2a472e92.pdf";